<template>
    <div class="col-lg-12">
        <div v-if="!isLoaded">
            <div class="text-center">
                Cargando...
            </div>
        </div>
        <div v-if="isLoaded">
            <p>
                <b>Información de REPSE</b> <br>
                Del <b>{{ formatDate(props.selectedData.start_date) }}</b> al <b>{{
                    formatDate(props.selectedData.end_date) }}</b>.<br>
                Colaborador: <b>{{ props.selectedData.user_name }}</b><br>
                Cliente: <b>{{ props.selectedData.client_name }}</b> <br>
                <span v-if="isNexon"><b>Se listan los registros de Nexon Automation y otros clientes cuyas tareas NO fueron realizadas en sitio.</b></span><br>
                <span v-if="props.selectedData.only_auth"><b>SOLO SE LISTAN REGISTROS AUTORIZADOS</b></span>
            </p>
            <div class="table-responsive">
                <table class="table table-bordered text-center align-middle">
                    <thead>
                        <th>Fecha</th>
                        <th>
                            Proyecto
                        </th>
                        <th>
                            Total de horas
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="r in rows" :key="r.date">
                            <td>
                                {{ formatDate(r.date) }}
                            </td>
                            <td>
                                {{ r.project }}
                            </td>
                            <td>
                                {{ r.total_hours.toFixed(2) }} hrs
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2"></td>
                            <td><b>{{ props.selectedData.total_client_hours }} hrs</b></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script setup>

import { onMounted, ref } from "vue"
import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;


const props = defineProps({
    selectedData: Object
});

const isLoaded = ref(false)
const rows = ref([])
const isNexon = ref(false)

const getClientUserData = async () => {

    const body = {
        start_date: props.selectedData.start_date,
        end_date: props.selectedData.end_date,
        user_id: props.selectedData.user_id,
        client_id: props.selectedData.client_id,
        only_auth: props.selectedData.only_auth,
    }

    if(props.selectedData.client_id === 2) {
        isNexon.value = true
    }

    rows.value = []

    try {
        const response = await axios.post(`${API_BASE_URL}/get-repse-stats-per-client-user`, body, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        rows.value = response.data
        isLoaded.value = true
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }

}

const formatDate = (isoDateString) => {
    const date = new Date(isoDateString)

    // Asegura usar los datos en UTC para evitar desfase
    const day = String(date.getUTCDate()).padStart(2, '0')
    const month = String(date.getUTCMonth() + 1).padStart(2, '0')
    const year = date.getUTCFullYear()

    return `${day}/${month}/${year}`
}

// Inicializa el DataTable después de obtener los datos
onMounted(async () => {
    await getClientUserData()
});

</script>